// The login-attempts API stores the raw User-Agent header. Rather than make
// the backend own the parsing rules, the header is turned into a readable
// browser/OS pair here, at display time. Order matters in both tables: Edge
// and Opera also advertise "Chrome", and Chrome also advertises "Safari".
const BROWSERS = [
  { name: "Edge", pattern: /Edg(?:e|A|iOS)?\/([\d.]+)/ },
  { name: "Opera", pattern: /(?:OPR|Opera)\/([\d.]+)/ },
  { name: "Samsung Internet", pattern: /SamsungBrowser\/([\d.]+)/ },
  { name: "Chrome", pattern: /(?:Chrome|CriOS)\/([\d.]+)/ },
  { name: "Firefox", pattern: /(?:Firefox|FxiOS)\/([\d.]+)/ },
  { name: "Safari", pattern: /Version\/([\d.]+).*Safari/ },
  { name: "Internet Explorer", pattern: /(?:MSIE |rv:)([\d.]+).*Trident/ },
  { name: "curl", pattern: /curl\/([\d.]+)/ },
];

const SYSTEMS = [
  { name: "Windows", pattern: /Windows NT [\d.]+/ },
  { name: "Android", pattern: /Android [\d.]+/ },
  { name: "iOS", pattern: /(?:iPhone|iPad|iPod).*OS [\d_]+/ },
  { name: "macOS", pattern: /Mac OS X [\d_.]+/ },
  { name: "Linux", pattern: /Linux/ },
];

// Only the leading major version is kept - a full "140.0.7339.16" adds noise
// to a table cell without telling an operator anything extra.
function majorVersion(version) {
  if (!version) return null;
  return version.split(".")[0];
}

export function getBrowser(userAgent) {
  if (!userAgent) return null;
  for (const browser of BROWSERS) {
    const match = userAgent.match(browser.pattern);
    if (match) {
      const version = majorVersion(match[1]);
      return version ? browser.name + " " + version : browser.name;
    }
  }
  return null;
}

export function getOperatingSystem(userAgent) {
  if (!userAgent) return null;
  for (const system of SYSTEMS) {
    if (system.pattern.test(userAgent)) return system.name;
  }
  return null;
}

// A server-supplied browser/os wins when present, so the backend can start
// sending parsed values later without this file having to change.
export function describeUserAgent(attempt) {
  const userAgent = attempt?.userAgent;
  return {
    browser: attempt?.browser || getBrowser(userAgent),
    os: attempt?.os || getOperatingSystem(userAgent),
  };
}
